export default __webpack_public_path__ + "media/img_01/300-167429fc.jpg";